import { useState } from "react";
import { Link2, MessageCircle, Share2, Check } from "lucide-react";

export default function ShareButtons({ url, title, size = "sm" }) {
  const [copied, setCopied] = useState(false);

  const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
  const encodedUrl = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title);

  const copyLink = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
      const input = document.createElement("input");
      input.value = fullUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareWhatsApp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`, "_blank");
  };

  const iconSize = size === "sm" ? 14 : 16;
  const btnClass = size === "sm"
    ? "w-8 h-8 rounded-full flex items-center justify-center transition-all"
    : "w-10 h-10 rounded-full flex items-center justify-center transition-all";

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={copyLink}
        className={`${btnClass} ${copied ? "bg-green-600" : "bg-white/10 hover:bg-white/20"}`}
        title={copied ? "Link copiado!" : "Copiar link"}
        data-testid="copy-link-btn"
      >
        {copied ? <Check size={iconSize} className="text-white" /> : <Link2 size={iconSize} className="text-zinc-400" />}
      </button>
      <button
        onClick={shareWhatsApp}
        className={`${btnClass} bg-white/10 hover:bg-[#25D366]`}
        title="Enviar no WhatsApp"
        data-testid="share-whatsapp-btn"
      >
        <MessageCircle size={iconSize} className="text-zinc-400 hover:text-white" />
      </button>
    </div>
  );
}
